/** The parts of a rematch response that decide what the user is told. */
export interface RematchResultSummary {
  outcome: 'completed' | 'source_changed' | 'invoice_matching_failed';
  counts: { ambiguous: number; unmatched: number };
  memory: { outcome: string; explanation: string } | null;
}

export type RematchNotice =
  | { kind: 'source_changed' }
  | { kind: 'invoice_matching_failed' }
  | { kind: 'memory_not_applied'; explanation: string }
  | { kind: 'lines_need_review' }
  | { kind: 'complete' };

/**
 * Which toasts a rematch produces, in order. A note that could not be turned
 * into rules leaves ordinary matching in place, which otherwise looks
 * identical to the note having no effect, so it is reported alongside any
 * unresolved lines and is never followed by a success message.
 */
export function rematchNotices(result: RematchResultSummary): RematchNotice[] {
  if (result.outcome !== 'completed') return [{ kind: result.outcome }];

  const notices: RematchNotice[] = [];
  if (result.memory && result.memory.outcome !== 'interpreted') {
    notices.push({
      kind: 'memory_not_applied',
      explanation: result.memory.explanation,
    });
  }
  if (result.counts.ambiguous > 0 || result.counts.unmatched > 0) {
    notices.push({ kind: 'lines_need_review' });
  }
  return notices.length ? notices : [{ kind: 'complete' }];
}
